import { ROUTE_TESTING_PLAN } from '@/constants/routes';
import { Box, Text, Link } from '@cmpsr/components';
import { Link as RouterLink } from 'react-router-dom';

export default function EmptyState() {
  return (
    <Box
      textAlign="left"
      px="5"
      py="8"
      pt={{ base: '12', lg: '8' }}
      border="1px solid"
      borderColor="ui-element-divider"
      borderRadius="radii-3"
    >
      <Text variant="text-header-XL" mb="spacer-2">
        You have not completed any tests
      </Text>
      <Text variant="text-body-regular">Check out your plan to get started</Text>
      <Link as={RouterLink} to={`${ROUTE_TESTING_PLAN}?tab=to-do`} variant="primary" size="m" mt="8">
        Create Plan
      </Link>
    </Box>
  );
}
